var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5L7.4276 8.26414C9.55141 9.4675 10.4487 9.4675 12.5726 8.26414L18.3334 5",
    stroke: "#808080",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67989 11.2297C1.73436 13.7843 1.76161 15.0616 2.70421 16.0078C3.64681 16.954 4.95869 16.9869 7.58244 17.0528C9.1995 17.0935 10.8007 17.0935 12.4177 17.0528C15.0415 16.9869 16.3533 16.954 17.296 16.0078C18.2386 15.0616 18.2658 13.7843 18.3202 11.2297C18.3378 10.4082 18.3378 9.59174 18.3202 8.77032C18.2658 6.21571 18.2386 4.9384 17.296 3.99221C16.3533 3.04602 15.0415 3.01306 12.4177 2.94713C10.8007 2.9065 9.1995 2.9065 7.58243 2.94712C4.95869 3.01304 3.64681 3.046 2.70421 3.9922C1.7616 4.93839 1.73436 6.2157 1.67988 8.77032C1.66236 9.59174 1.66237 10.4082 1.67989 11.2297Z",
    stroke: "#808080",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.60b022ebc5e9f450cea48f8659075b9d.svg";
export { ForwardRef as ReactComponent };